import { SvgIcon, SvgIconProps } from "@mui/material";

export const UploadIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24">
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M14.445 12.89a.73.73 0 0 0 1.04 0 .739.739 0 0 0 .01-1.05l-2.842-2.88a.768.768 0 0 0-.515-.22.768.768 0 0 0-.525.22l-2.831 2.88a.748.748 0 0 0 0 1.05.73.73 0 0 0 1.04 0l1.574-1.6v4.83a.737.737 0 1 0 1.475 0v-4.83l1.574 1.6Zm5.383-3.864c.233-.003.486-.006.717-.006.247 0 .455.2.455.45v8.04c0 2.48-2 4.49-4.455 4.49H8.673C6.09 22 4 19.89 4 17.29V6.51C4 4.03 5.99 2 8.465 2h5.287c.248 0 .456.21.456.46v3.22c0 1.83 1.485 3.33 3.307 3.34.416 0 .786.003 1.11.006.255.002.482.004.682.004.14 0 .324-.002.521-.004Zm.276-1.459c-.814.003-1.772 0-2.462-.007-1.095 0-1.997-.91-1.997-2.017V2.907c0-.43.516-.645.812-.334a9238.645 9238.645 0 0 1 3.988 4.187.477.477 0 0 1-.341.807Z"
        clip-rule="evenodd"
      />
    </svg>{" "}
  </SvgIcon>
);
